import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import SignInChangePasswordForm from "@insite/content-library/Widgets/SignIn/SignInChangePasswordForm";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps } from "@insite/mobius/Icon/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Img, { ImgProps } from "@insite/mobius/Img";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import recoverUsernamePassword from "@NA/Handlers/ADIRecoverUsernamePasswordHandler";
import signInAssist from "@NA/Handlers/ADISignInAssistHandler";
import multiplevalidateReCaptcha from "@NA/Handlers/MultipleRecaptcha/ADIValidateReCaptchaHandler";
import ErrorIcon from "@NA/Icons/ErrorIcon";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import { getRememberedUserName } from "@NA/Utils/Utility";
import { result } from "lodash";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { getStatuscall } from "@NA/Services/ADIgetStatusCall"; // This import has been implemented by P21
import { clearCoveoTokenAndOrg } from "@NA/Services/ADICoveoService";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";

const enum fields {
    changePasswordInstructions = "changePasswordInstructions",
    image = "image",
    captchaIds = "captchaIds",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.changePasswordInstructions]: string;
        [fields.image]: string;
        [fields.captchaIds]: string;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const parsedQuery = parseQueryString<{ externalError?: string }>(getLocation(state).search);
    return {
        accountSettings: getSettingsCollection(state).accountSettings,
        externalError: parsedQuery.externalError,
        session: state.context.session,
        currentLocation: getLocation(state),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const mapDispatchToProps = {
    signIn,
    validateReCaptcha: makeHandlerChainAwaitable<any, boolean>(multiplevalidateReCaptcha),
    recoverUsernamePassword,
    signInAssist,
};
const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();
export interface ADISignInAssistStyles {
    container?: GridContainerProps;
    innerContainer?: InjectableCss;
    headingErrorMessage?: InjectableCss; // This property is being used by P21
    contactUsMessage?: InjectableCss; // This property is being used by P21
    leftGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
    form?: InjectableCss;
    heading?: TypographyPresentationProps;
    emailSendHeading?: TypographyPresentationProps;
    emailSendWrapper?: InjectableCss;
    rememberMeCheckbox?: CheckboxProps;
    rememberMeCheckboxGroup?: CheckboxGroupComponentProps;
    userNameTextField?: TextFieldProps;
    signInGridContainer?: GridContainerProps;
    icon?: IconProps;
    passwordTextField?: TextFieldProps;
    signInButton?: ButtonPresentationProps;
    registerButton?: ButtonPresentationProps;
    signInButtonGridItem?: GridItemProps;
    registerButtonGridItem?: GridItemProps;
    forgotPasswordGridItem?: GridItemProps;
    rememberMeGridItem?: GridItemProps;
    passwordGridItem?: GridItemProps;
    userNameGridItem?: GridItemProps;
    signInExistingAccountTitle?: TypographyProps;
    forgotPasswordLink?: LinkPresentationProps;
    resetPasswordModal?: ModalPresentationProps;
    changePasswordModal?: ModalPresentationProps;
    formErrorMessage?: InjectableCss;
    errorMessageStyling?: TypographyPresentationProps;
    requirementsTextWrapper: InjectableCss;
    requirementsText: TypographyPresentationProps;
    requirementsErrorText: TypographyPresentationProps;
    img?: ImgProps;
    errorStyleWrapper?: InjectableCss;
    imageLink?: LinkPresentationProps;
    imageLinkPadding?: LinkPresentationProps;
    registartionTxt?: TypographyPresentationProps;
    recaptchaGridContainer: GridItemProps;
}

export const signInAssistStyles: ADISignInAssistStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: center;
        `,
        offsetCss: css`
            justify-content: center;
            margin: 2rem 0rem;
            width: 100% !important;
            background: ${ADIColors.white1};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        width: 60% !important;
                    `,
                    css`
                        width: 60% !important;
                    `,
                    css`
                        width: 80% !important;
                    `,
                ])}
        `,
    },
    innerContainer: {
        css: css`
            width: 80%;
            padding: 0rem;
            background: ${ADIColors.white1};
            border-radius: 5px;
            display: flex;
        `,
    },
    // This stype property is being used by P21
    headingErrorMessage: {
        css: css`
            width: 100%;
            text-align: center;
        `,
    },
    // This stype property is being used by P21
    contactUsMessage: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 0;
            font-size: 14px;
            font-weight: normal;
        `,
    },
    leftGridItem: {
        width: [12, 12, 12, 12, 6],
        css: css`
            flex-direction: column;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        padding: 6rem 4rem;
                    `,
                ])}
        `,
    },
    rightGridItem: {
        width: [12, 12, 12, 12, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        padding: 6rem 4rem;
                        border-left: 2px solid ${ADIColors.gray21};
                    `,
                ])}
        `,
    },
    emailSendWrapper: {
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        padding: 12rem 0rem;
                    `,
                ])}
        `,
    },
    img: {
        css: css`
            width: 140px;
            height: 140px;
        `,
    },
    imageLink: {
        css: css`
            margin: 2rem 0 3.5rem;
            > ${TypographyStyle} {
                display: inline-flex;
            }
        `,
    },
    imageLinkPadding: {
        css: css`
            margin: 13rem 0;
            > ${TypographyStyle} {
                display: inline-flex;
            }
        `,
    },
    form: {
        css: css``,
    },
    icon: {
        css: css`
            padding-top: 50px;
        `,
    },
    signInExistingAccountTitle: {
        variant: "h4",
    },
    userNameGridItem: {
        width: 12,
        css: css``,
    },
    passwordGridItem: {
        width: 12,
        css: css``,
    },
    signInButtonGridItem: {
        width: 12,
        css: css``,
    },
    registerButtonGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    rememberMeGridItem: {
        width: 12,
        css: css`
            padding: 0px 15px;
        `,
    },
    forgotPasswordGridItem: {
        width: 12,
        css: css`
            padding: 0px 15px;
        `,
    },
    forgotPasswordLink: {
        typographyProps: {
            size: 13,
            css: css``,
        },
    },
    signInButton: {
        css: css`
            width: 100%;
        `,
    },
    registerButton: {
        css: css`
            border-radius: 4px;
            border: solid 1px ${ADIColors.blue1};
            background-color: ${getColor("common.background")};
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            line-height: normal;
            text-align: center;
            height: 40px;
            > span {
                color: ${ADIColors.blue1};
            }
            &:hover {
                background-color: ${ADIColors.secondaryButtonHoverLightBlue} !important;
            }
        `,
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
    changePasswordModal: {
        sizeVariant: "small",
    },
    formErrorMessage: {
        css: css`
            margin-bottom: 15px;
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: ${ADIColors.danger};
            float: left;
            width: 100%;
            padding-left: 15px;
        `,
    },

    heading: {
        css: css`
            padding: 0px 15px;
            margin-bottom: 0px !important;
            text-align: left;
        `,
    },
    emailSendHeading: {
        css: css`
            padding: 0px 15px;
            margin-bottom: 0px !important;
            text-align: left;
            display: flex;
            align-items: center;
            img {
                min-width: 26px;
                margin-right: 8px;
                width: 12px;
            }
        `,
    },
    signInGridContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: auto;
            }
        `,
    },
    requirementsTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-top: 2rem;
        `,
    },
    requirementsText: {
        css: css`
            padding-left: 15px;
        `,
    },
    requirementsErrorText: {
        css: css`
            padding-left: 30px;
            color: ${ADIColors.errorFields};
        `,
    },
    errorStyleWrapper: {
        css: css`
            border-radius: 5px;
            box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.22);
            background-color: #fff;
            padding: 15px 10px 15px 12px;
            min-height: 46px;
            border-left: 4px solid #ac1e2d;
            display: inline-flex;
            align-items: flex-start;
            margin: 0;
            width: 100%;
        `,
    },
    registartionTxt: {
        css: css`
            font-weight: bold;
        `,
    },
    recaptchaGridContainer: {
        width: 12,
        css: css`
            padding: 0 15px;
            margin: 29px 0 30px 0 !important;
        `,
    },
    errorMessageStyling: {
        css: css`
            margin-left: 10px;
        `,
    },
};

/**
 * @deprecated Use signInExistingAccountStyles instead.
 */
export const SignInAssist = signInAssistStyles;
const styles = signInAssistStyles;
const StyledForm = getStyledWrapper("form");

const PasswordNotFound = (userName: any) => {
    return (
        <>
            <StyledWrapper {...styles.emailSendWrapper}>
                <Typography {...styles.emailSendHeading} variant="h3">
                    <img src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/MyBranchImages/icon-check-green.png" />
                    {translate("Password Reset Email Sent")}
                </Typography>
                <Typography>
                    {translate(
                        `An email has been sent to ${userName?.userName}. You will receive the email shortly with a link to reset your password.`,
                    )}
                </Typography>
            </StyledWrapper>
        </>
    );
};

const UserNotFound = ({ isMobile, setUserName, userName, rememberedUserName, recoverpassword }: any) => {
    // recoverpassowrd has been added by P21

    return (
        <>
            <GridContainer {...styles.signInGridContainer}>
                <Typography variant="h3">{translate("Password Assistance")}</Typography>
                <Typography variant="h6">
                    {translate('Enter the Email Address associated with your Sign In and click "Continue."')}
                </Typography>

                <GridItem {...styles.userNameGridItem}>
                    <TextField
                        id="userName"
                        {...styles.userNameTextField}
                        label={!isMobile ? translate("Username (Email Address)") : translate("Email Address")}
                        onChange={e => {
                            setUserName(e.currentTarget.value);
                        }}
                        value={userName || rememberedUserName}
                        autoComplete="username"
                        data-test-selector="signIn_userName"
                        placeholder="Email Address"
                        required
                    />
                </GridItem>
                <GridItem {...styles.recaptchaGridContainer}>
                    <ReCaptcha recaptchaRef={recaptchaRef} location="ForgotPassword" />
                </GridItem>
                <GridItem {...styles.signInButtonGridItem}>
                    {/* onClick is being used by P21 */}
                    <Button
                        {...styles.signInButton}
                        type="submit"
                        data-test-selector="signIn_submit"
                        onClick={recoverpassword}
                    >
                        {translate("Continue")}
                    </Button>
                </GridItem>
            </GridContainer>
        </>
    );
};

const ADISignInAssist = ({
    signIn,
    fields,
    accountSettings,
    externalError,
    session,
    validateReCaptcha,
    currentLocation,
    recoverUsernamePassword,
    signInAssist,
    history,
}: Props) => {
    const [rememberedUserName, setRememberedUserName] = useState(getRememberedUserName());
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [isSignInClicked, setIsSignInClicked] = useState(false);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(externalError || "");
    const [isUserNameError, setIsUserNameError] = useState(false);
    const [isPasswordError, setPasswordError] = useState(false);
    const [isGlobalError, setIsGlobalError] = useState(false);
    const [isMobile, setIsMobile] = React.useState(false);
    const [loginAttempt, setLoginAttempt] = useState(1);
    const [disableSignIn, setDisableSignIn] = useState(false);
    const [signInError, setSignInError] = useState("");
    const showRememberMe = accountSettings.rememberMe;
    const captchaIds = fields.captchaIds ? fields.captchaIds.split(",") : [];
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const [isUserNameErrorLocal, setIsUserNameErrorLocal] = useState<boolean | null>(null);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");
    const [captchaVal, setCaptchaVal] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [renderScreen, setRenderScreen] = useState("AssistForm");
    const [headingError, setHeadingError] = useState<string>("");

    const [errorType, setErrorType] = useState("");
    const [showCustomerStatusBanner, setShowCustomerStatusBanner] = useState<boolean>(); // P21 Change

    React.useEffect(() => {
        const onWindowResize = () => {
            setIsMobile(window.innerWidth < 700);
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    // This function is being used by P21
    const recoverpassword = () => {
        const grecaptcha = (window as { [key: string]: any })["grecaptcha"];
        if (grecaptcha === undefined) {
            return;
        }
        const captchaResponseValue = grecaptcha.getResponse();
        recoverUsernamePassword({
            userEmail: userName,
            passwordEmail: userName,
            isPasswordReset: true,
            isuserNameReset: false,
            userNotFound: false,
            isSuccess: false,
            uri: "",
            properties: { captchaResponse: captchaResponseValue, isEmailSend: false },
            onSuccess: (result: any) => {
                if (result.errorMessage) {
                    setCaptchaErrorMessage("Please click captcha.");
                    setHeadingError("The Captcha Input is Missing");
                    setErrorType("captcha");
                } else if (result.result.userNotFound || !captchaResponseValue) {
                    setErrorType("username");
                    setShowSuccessMessage(false);
                    setCaptchaErrorMessage("");
                    setHeadingError("Please Enter a Valid Username");
                    grecaptcha.reset();
                } else if (result.successful && result.result.isSuccess) {
                    setShowSuccessMessage(true);
                    setRenderScreen("PassWordForm");
                } else {
                    setCaptchaErrorMessage("");
                    setHeadingError("");
                    setErrorType("");
                }
            },
        });
    };

    const signInFailed = (error: any) => {
        setSignInError(error.message);
        setLoginAttempt(loginAttempt => loginAttempt + 1);
        setDisableSignIn(false);

        if (loginAttempt >= 3) {
            recoverUsernamePassword({
                userEmail: "noCaptchaValidation",
                passwordEmail: userName,
                isPasswordReset: true,
                isuserNameReset: false,
                userNotFound: false,
                isSuccess: false,
                uri: "",
                properties: { captchaResponse: captchaVal, isEmailSend: false },
                onSuccess: (result: any) => {
                    if (result.result.isSuccess) {
                        setShowSuccessMessage(true);
                        setRenderScreen("PassWordForm");
                    }
                    if (result.result.userNotFound) {
                        setRenderScreen("UserForm");
                    }
                },
            });
            signInAssist({
                userName: userName,
                eventName: "Login Failed",
                eventDescription: "Login failure",
                properties: null,
                uri: null,
            });
        } else {
            recoverUsernamePassword({
                userEmail: "noCaptchaValidation",
                passwordEmail: userName,
                isPasswordReset: true,
                isuserNameReset: false,
                userNotFound: false,
                isSuccess: false,
                uri: "",
                properties: { captchaResponse: "", isEmailSend: true },
                onSuccess: (result: any) => {
                    if (result.result.isSuccess) {
                        setShowSuccessMessage(false);
                        setRenderScreen("AssistForm");
                    }
                    if (result.result.userNotFound || !userName) {
                        setIsUserNameErrorLocal(true);
                        setErrorType("username");
                        setHeadingError("Please Enter a Valid Username");
                    } else {
                        setIsUserNameErrorLocal(false);
                        setErrorType("password");
                        setHeadingError("Please Enter a Valid Password");
                    }
                },
            });
            signInAssist({
                userName: userName,
                eventName: "Login Failed",
                eventDescription: "Login failure",
                properties: null,
                uri: null,
            });
        }
    };
    React.useEffect(() => {
        const getUserName = window?.localStorage.getItem("userNameSA");
        // window.localStorage.removeItem("userNameSA");
        const isUserNameError = window.localStorage.getItem("isUserNameError") === "true" ? true : false;
        setIsUserNameErrorLocal(isUserNameError);
        if (isUserNameError) {
            setErrorType("username");
            setHeadingError("Please Enter a Valid Username");
        } else {
            setErrorType("password");
            setHeadingError("Please Enter a Valid Password");
        }

        setUserName(getUserName!);
        setPassword("");
    }, []);

    const signInHandler = (newPassword?: string) => {
        const pass = newPassword || password;
        const user = (userName || rememberedUserName) as string;
        setIsSignInClicked(true);

        !user ? setIsUserNameError(true) : setIsUserNameError(false);

        !pass ? setPasswordError(true) : setPasswordError(false);
        const isGlobalErrorOccured = !user || !pass;

        setIsGlobalError(isGlobalErrorOccured);

        if (isGlobalErrorOccured) return;

        if (accountSettings.useEmailAsUserName && !validateEmail(user)) return;

        const returnUrl = currentLocation.pathname + currentLocation.search;

        setErrorMessage("");

        const isReCaptchaValid = validateReCaptcha({ captchaIds });
        if (!isReCaptchaValid) {
            return;
        }

        const grecaptcha = (window as { [key: string]: any })["grecaptcha"];
        if (grecaptcha === undefined) {
            return;
        }

        const captchaResponse = document?.getElementById("g-recaptcha-response") as HTMLTextAreaElement;
        const captchaResponseVal = captchaResponse.value;
        setCaptchaVal(captchaResponseVal);

        if (!captchaResponseVal) {
            setCaptchaErrorMessage("Please click captcha.");
            setHeadingError("The Captcha Input is Missing");
            setErrorType("captcha");
            return;
        } else {
            setCaptchaErrorMessage("");
            setErrorType("");
        }
        localStorage.removeItem("sessionStartTime");
        signIn({
            userName: user,
            password: pass,
            rememberMe,
            returnUrl,
            onError: (error, statusCode) => {
                if (statusCode === 422) {
                    setIsChangePasswordModalOpen(true);
                    return;
                } else {
                    setErrorMessage(error);
                    signInFailed(error);
                }
            },
        });
        signInAssist({
            userName: userName,
            eventName: "Login Success",
            eventDescription: "Login successful",
            properties: null,
            uri: null,
        });
    };

    // This function is being used by P21
    async function getStatusCall() {
        await getStatuscall()
            .then(response => {
                const showCustomerStatusBanner = (response as any)?.response?.showCustomerStatusBanner;
                setShowCustomerStatusBanner(showCustomerStatusBanner);
                localStorage.setItem("showCustomerStatusBanner", showCustomerStatusBanner);
            })
            .catch(err => {
                return err;
            });
    }

    useEffect(() => {
        if (session.isAuthenticated) {
            // getStatusCall();
            const dataLayer = (window as any).dataLayer || [];
            const userId = session && session.userProfileId;
            clearCoveoTokenAndOrg();

            if (dataLayer) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "Successful login",
                    ecommerce: {
                        authenticationState: "Logged In",
                        userId: userId || "",
                    },
                });
            }
            return dataLayer;
        }
    }, [session.isAuthenticated]);

    useEffect(() => {
        if (rememberedUserName) localStorage.setItem("rememberedUserName", rememberedUserName);
    }, [rememberedUserName]);

    useEffect(() => {
        const rememberMeValue = localStorage.getItem("rememberMe");
        setRememberMe(rememberMeValue === "true" ? true : false);
    }, []);

    const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        signInHandler();
        if (rememberMe) {
            localStorage.setItem("rememberMe", rememberMe.toString());
            localStorage.setItem("rememberedUserName", userName);
        } else {
            localStorage.setItem("rememberMe", rememberMe.toString());
        }
    };

    const onChangePasswordClose = () => {
        setIsChangePasswordModalOpen(false);
    };

    const onPasswordChanged = (newPassword: string) => {
        setPassword(newPassword);
        setIsChangePasswordModalOpen(false);
        signInHandler(newPassword);
    };

    const validateUserName = () => {
        if (isSignInClicked) {
            if (userName) {
                if (accountSettings.useEmailAsUserName && !validateEmail(userName)) {
                    return siteMessage("SignInInfo_Email_Validation");
                }
            } else {
                return accountSettings.useEmailAsUserName
                    ? siteMessage("SignInInfo_Email_Required")
                    : siteMessage("SignInInfo_UserName_Required");
            }
        }

        return "";
    };

    const forgetPasswordHandler = () => {
        if (!isAuthenticated) {
            history.push("/MyAccount/recoverusernamepassword");
        }
    };

    const redirectToSignIn = () => {
        window.location.href = "/MyAccount/SignIn";
    };

    return (
        <>
            <LoadingOverlay loading={isLoading} spinnerProps={{ color: "primary" }}>
                <GridContainer {...styles.container}>
                    <GridItem {...styles.leftGridItem}>
                        <Link href="/" {...(!showSuccessMessage ? styles.imageLink : styles.imageLinkPadding)}>
                            <Img src={fields.image} altText="Logo" loading="lazy" {...styles.img} />
                        </Link>
                        {!showSuccessMessage && errorType && (
                            <>
                                {/* ...styles.headingErrorMessage is being used by P21  */}
                                <Typography variant="h3" {...styles.headingErrorMessage}>
                                    {translate(headingError)}
                                </Typography>
                                <StyledWrapper {...styles.errorStyleWrapper}>
                                    <ErrorIcon />
                                    {errorType === "username" && !captchaErrorMessage && (
                                        <Typography {...styles.errorMessageStyling}>
                                            {translate("The username you entered cannot be found.")}
                                        </Typography>
                                    )}
                                    {errorType === "password" && !captchaErrorMessage && (
                                        <Typography {...styles.errorMessageStyling}>
                                            {translate("The password you entered is incorrect.")}
                                        </Typography>
                                    )}
                                    {errorType === "captcha" && userName !== "" && password !== "" && (
                                        <Typography {...styles.errorMessageStyling}>{captchaErrorMessage}</Typography>
                                    )}
                                </StyledWrapper>
                            </>
                        )}
                    </GridItem>
                    <GridItem {...styles.rightGridItem}>
                        {renderScreen === "AssistForm" && (
                            <StyledForm {...styles.form} onSubmit={submitHandler} noValidate>
                                <Typography {...styles.heading} variant="h3">
                                    {translate("Sign In")}
                                </Typography>

                                <GridContainer {...styles.signInGridContainer}>
                                    <GridItem {...styles.userNameGridItem}>
                                        <TextField
                                            id="userName"
                                            {...styles.userNameTextField}
                                            label={
                                                !isMobile
                                                    ? translate("Username (Email Address)")
                                                    : translate("Email Address")
                                            }
                                            onChange={e => {
                                                setUserName(e.currentTarget.value);
                                                setRememberedUserName("");
                                            }}
                                            value={rememberedUserName || userName}
                                            autoComplete="username"
                                            data-test-selector="signIn_userName"
                                            placeholder="Email Address"
                                            required
                                        />
                                    </GridItem>
                                    <GridItem {...styles.passwordGridItem}>
                                        <TextField
                                            id="password"
                                            {...styles.passwordTextField}
                                            label={translate("Password")}
                                            onChange={e => setPassword(e.currentTarget.value)}
                                            value={password}
                                            iconProps={{
                                                ...styles.icon,
                                                src: showPassword ? Eye : EyeOff,
                                            }}
                                            iconClickableProps={{
                                                onClick: () => {
                                                    setShowPassword(!showPassword);
                                                },
                                                type: "button",
                                            }}
                                            required
                                            clickableText={password}
                                            autoComplete="current-password"
                                            data-test-selector="signIn_password"
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Enter value here..."
                                        />
                                    </GridItem>
                                    <GridItem {...styles.forgotPasswordGridItem}>
                                        <Link
                                            {...styles.forgotPasswordLink}
                                            type="button"
                                            onClick={forgetPasswordHandler}
                                            data-test-selector="signIn_forgotPassword"
                                        >
                                            {translate("Forgot username or password?")}
                                        </Link>
                                    </GridItem>
                                    <GridItem {...styles.recaptchaGridContainer}>
                                        <ReCaptcha recaptchaRef={recaptchaRef} location="ForgotPassword" />
                                    </GridItem>
                                    <GridItem {...styles.signInButtonGridItem}>
                                        <Button
                                            {...styles.signInButton}
                                            type="submit"
                                            data-test-selector="signIn_submit"
                                        >
                                            {translate("Sign In")}
                                        </Button>
                                        <Modal
                                            headline={translate("Change Password")}
                                            {...styles.changePasswordModal}
                                            isOpen={isChangePasswordModalOpen}
                                            handleClose={onChangePasswordClose}
                                        >
                                            <SignInChangePasswordForm
                                                enteredUserName={userName}
                                                enteredPassword={password}
                                                instructionsText={fields.changePasswordInstructions}
                                                onPasswordChanged={onPasswordChanged}
                                            />
                                        </Modal>
                                    </GridItem>
                                    <GridItem {...styles.rememberMeGridItem}>
                                        {showRememberMe && (
                                            <CheckboxGroup {...styles.rememberMeCheckboxGroup}>
                                                <Checkbox
                                                    uid="rememberMe"
                                                    {...styles.rememberMeCheckbox}
                                                    checked={rememberMe}
                                                    onChange={(e, value) => setRememberMe(value)}
                                                >
                                                    {translate("Remember Me")}
                                                </Checkbox>
                                            </CheckboxGroup>
                                        )}
                                    </GridItem>
                                    <GridItem {...styles.registerButtonGridItem}>
                                        <Typography {...styles.registartionTxt}>New to the ADI Website?</Typography>
                                        <Button
                                            onClick={redirectToSignIn}
                                            {...styles.registerButton}
                                            data-test-selector="signIn_submit"
                                        >
                                            {translate("Register Now")}
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                            </StyledForm>
                        )}
                        {renderScreen === "PassWordForm" && (
                            <>
                                <PasswordNotFound userName={userName} />
                            </>
                        )}

                        {renderScreen === "UserForm" && (
                            <>
                                <UserNotFound
                                    isMobile={isMobile}
                                    setUserName={setUserName}
                                    userName={userName || rememberedUserName}
                                    isChangePasswordModalOpen={isChangePasswordModalOpen}
                                    onChangePasswordClose={onChangePasswordClose}
                                    password={password}
                                    onPasswordChanged={onPasswordChanged}
                                    recoverpassword={recoverpassword} // P21 Change
                                />
                            </>
                        )}
                    </GridItem>
                </GridContainer>
                {/* Below element is being used by P21  */}
                <Typography variant="p" {...styles.contactUsMessage}>
                    {translate("Need assistance? Contact Web Support at 1.877.228.6739")}
                </Typography>
            </LoadingOverlay>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADISignInAssist)),
    definition: {
        group: "Sign In",
        icon: "LogIn",
        displayName: "ADI SignIn Assist",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.changePasswordInstructions,
                editorTemplate: "RichTextField",
                displayName: "Change Password Instructions",
                defaultValue: "A password change is required for your account before you may continue.",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
            },
            {
                fieldType: "Translatable",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
